<template>
  <BaseModal
    name="employeeModal"
    width="500"
    @before-close="closeModal"
    @before-open="openModal"
    :clickToClose="false"
    :shiftY="0.5"
    :adaptive="true"
    height="auto"
    classes="tw-app-modal"
  >
    <div class="tw-app-modal__container">
      <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>
      <button
        type="button"
        class="btn-close tw-app-modal__close"
        @click="$modal.hide('employeeModal')"
      ></button>

      <div>
        <div class="tw-app-modal__title">{{ dataLang["reg_employee_11"] }}</div>

        <div v-if="!localLoading">
          <div v-if="!dataModal?.employees__is_admin && !localLoading">
            <div v-if="typeOfOpenModal == 'edit'">
              ФИО
              <span class="tw-text-forText">
                {{ dataModal?.employees__name }}
              </span>
            </div>
            <div class="tw-grid tw-grid-cols-2 tw-mt-[10px]">
              <div v-if="typeOfOpenModal == 'edit'">
                Телефон
                <div class="tw-text-forText">
                  {{ dataModal?.employees__phone }}
                </div>
              </div>
              <div v-if="typeOfOpenModal == 'edit'">
                Email
                <div class="tw-text-forText">
                  {{ dataModal?.employees__email }}
                </div>
              </div>
            </div>

            <div
              class="tw-my-[10px] tw-flex tw-gap-[10px] tw-items-center"
              v-if="typeOfOpenModal == 'edit'"
            >
              <div class="tw-whitespace-nowrap">
                Внутренний телефон (добавочный):
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                @input="updateValue"
                inputName="employees__internal_phone"
                :value="dataModal?.employees__internal_phone"
              />
            </div>

            <div v-if="typeOfOpenModal == 'create'" class="tw-mb-[15px]">
              <BaseSelect
                class="multiselect-type-3"
                style="width: 100%"
                placeholder=""
                selectLabel=""
                deselectLabel=""
                @input="
                  ({ clients__id }) =>
                    updateValue({
                      name: 'employees__client_id',
                      value: clients__id,
                    })
                "
                v-model="selectsData.client"
                :options="selectsListsData?.client"
                label="clients__name"
              >
                <template slot="noOptions">{{
                  dataLang["select_empty"]
                }}</template>
                <template slot="noResult">{{
                  dataLang["select_search_empty"]
                }}</template
                ><template slot="selectedLabel">{{
                  dataLang["select_selected"]
                }}</template>
                <template slot="deselectLabel">{{
                  dataLang["select_unselect"]
                }}</template>
                >
              </BaseSelect>
            </div>
          </div>

          <div v-if="!dataModal?.employees__is_admin && !localLoading">
            <div class="tw-mb-[15px]">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["reg_employee_13"] }}
              </div>
              <BaseSelect
                class="multiselect-type-3"
                placeholder=""
                selectLabel=""
                deselectLabel=""
                @input="
                  ({ employee_jobtitles__id }) =>
                    updateValue({
                      name: 'employees__jobtitle_id',
                      value: employee_jobtitles__id,
                    })
                "
                v-model="selectsData.jobtitle"
                :options="selectsListsData?.jobtitle"
                label="employee_jobtitles__name"
              >
                <template slot="noOptions">{{
                  dataLang["select_empty"]
                }}</template>
                <template slot="noResult">{{
                  dataLang["select_search_empty"]
                }}</template
                ><template slot="selectedLabel">{{
                  dataLang["select_selected"]
                }}</template>
                <template slot="deselectLabel">{{
                  dataLang["select_unselect"]
                }}</template>
                >
              </BaseSelect>
            </div>
          </div>

          <div v-if="!localLoading" class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">
              {{ dataLang["reg_employee_15"] }}
            </div>
            <BaseSelect
              class="multiselect-type-3"
              placeholder=""
              selectLabel=""
              deselectLabel=""
              @input="
                ({ id }) =>
                  updateValue({
                    name: 'employees__is_password_onetime',
                    value: id,
                  })
              "
              v-model="selectsData.typePassword"
              :options="selectsListsData?.typePassword"
              label="employee_jobtitles__name"
              :custom-label="
                ({ name }) =>
                  dataLang[name].charAt(0).toUpperCase() +
                  dataLang[name].slice(1)
              "
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template
              ><template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
          </div>

          <div
            v-if="!dataModal?.employees__is_admin && !localLoading"
            class="tw-mb-[15px]"
          >
            <div class="tw-app-input-type-3-label">
              {{ dataLang["reg_employee_16"] }}
            </div>
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              @input="updateValue"
              inputName="employees__allowed_ip"
              :value="dataModal?.employees__allowed_ip"
            />
          </div>

          <BaseCheckboxV2
            placeholder=""
            input-name="employees__is_login_blocked"
            v-model="isLock"
            @oncheckeds="updateValue"
            v-if="!dataModal?.employees__is_admin && !localLoading"
          >
            <span class="tw-text-[14px] tw-text-forTitle">
              {{ dataLang["reg_employee_17"] }}
            </span>
          </BaseCheckboxV2>
        </div>

        <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
          <button
            @click="$modal.hide('employeeModal')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            {{ dataLang["registry_ads_text8"] }}
          </button>
          <button
            @click="onSaveModal"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            {{ dataLang["registry_ads_text7"] }}
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import GeneralService from "@/api/GeneralService.js";
import { VeTable } from "vue-easytable";
import BidsService from "@/api/BidsService";
import EventBus from "@/event-bus.js";
import OwnersService from "@/api/OwnersService";

// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  components: {
    VeTable,
  },
  props: {
    stateLoading: {
      type: Boolean,
      default: false,
    },
    optionalParams: {
      type: Object,
    },
    dataForModal: { type: Object },
  },
  data() {
    return {
      selectLabel: "",
      localLoading: false,
      isLock: false,
      tableData: [],
      typeOfOpenModal: "",
      dataForEmit: {},
      dataModal: {},
      selectsListsData: {
        jobtitle: [],
        client: [],
        typePassword: [],
        jobtitles: [],
      },
      selectsData: {
        jobtitle: [],
        client: [],
        typePassword: [],
        jobtitles: [],
      },
    };
  },
  methods: {
    closeModal() {
      this.dataForEmit = {};
      this.dataModal = {};
      this.isLock = false;
      Object.keys(this.selectsListsData).forEach((field, index) => {
        this.selectsListsData[field] = [];
        this.selectsData[field] = [];
      });
    },

    onSaveModal() {
      this.localLoading = true;
      try {
        if (this.typeOfOpenModal == "edit") {
          GeneralService.edit(`/employees/${this.dataModal.employees__id}`, {
            employees__client_id: this.dataModal?.employees__id,
            ...this.dataForEmit,
          })
            .then((data) => {
              this.$toast.success(data.data.message);
            })
            .catch((e) => {
              this.$toast.error(e.response.data.message, { duration: 5000 });
            })
            .finally(() => {
              this.localLoading = false;
              EventBus.$emit("updateContentDataJobtitles");
              this.$modal.hide("employeeModal");
            });
        } else {
          GeneralService.editOrCreate(`/employees`, {
            ...this.dataForEmit,
          })
            .then((data) => {
              this.$toast.success(data.data.message);
            })
            .catch((e) => {
              this.$toast.error(e.response.data.message, { duration: 5000 });
            })
            .finally(() => {
              this.localLoading = false;
              EventBus.$emit("updateContentDataJobtitles");
              this.$modal.hide("employeeModal");
            });
        }
      } catch (error) {
        this.$toast.error(error, { duration: 5000 });
      }
    },
    openModal(data) {
      this.localLoading = true;
      this.typeOfOpenModal = data.params.type;
      if (this.typeOfOpenModal == "edit") {
        this.dataModal = data.params.data;
        this.isLock = this.dataModal.employees__is_login_blocked;
      } else {
        this.isLock = false;
      }

      Promise.all([
        GeneralService.get(`/employees/table/clients`)
          .then((data) => {
            this.selectsListsData.client = data.data.data;
          })
          .catch((e) => {}),
        GeneralService.get(`/employees/table/ptypes`)
          .then((data) => {
            this.selectsListsData.typePassword = data.data.data;
          })
          .catch((e) => {}),
        this.typeOfOpenModal == "edit"
          ? GeneralService.get(
              `/employees/table/get/${this.dataModal.employees__id}`
            )
              .then((data) => {
                this.dataModal = Object.assign(this.dataModal, data.data.data);
              })
              .catch((e) => {})
          : "",
        GeneralService.get(`/jobtitles`)
          .then((data) => {
            this.selectsListsData.jobtitle = data.data.data;
          })
          .catch((e) => {}),
      ])
        .then(() => {
          if (this.typeOfOpenModal == "create") {
            this.dataForEmit.employees__is_password_onetime = 0;
          }
          if (this.typeOfOpenModal == "edit") {
            this.selectsData.client.clients__name =
              this.dataModal.employees__name;
            if (this.selectsListsData?.jobtitle?.length) {
              this.selectsData.jobtitle = this.selectsListsData.jobtitle.find(
                (x) => {
                  return (
                    x.employee_jobtitles__id ==
                    this.dataModal.employees__jobtitle_id
                  );
                }
              );
            }
            if (this.selectsListsData?.typePassword?.length) {
              this.selectsData.typePassword =
                this.selectsListsData.typePassword.find((x) => {
                  return x.id == this.dataModal.employees__is_password_onetime;
                });
            }
          } else {
            if (this.selectsListsData?.typePassword?.length) {
              this.selectsData.typePassword =
                this.selectsListsData.typePassword.find((x) => {
                  return x.id == 0;
                });
            }
          }
        })
        .finally(() => (this.localLoading = false));
    },
    updateValue(data) {
      this.dataForEmit[data.name] = data.value;
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
  },
  mounted() {},
  created() {},
  beforeDestroy() {},

  computed: {
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
